import { gql } from '@apollo/client';

export const GET_CONTENT_POINTS_BY_OUTCOME = gql`
  query GetContentPointsByOutcome($input: GetContentPointsByOutcomeInput!) {
    getContentPointsByOutcome(input: $input) {
      id
      heading
      name
      subject
      stage
      content
      outcomes {
        id
      }
    }
  }
`;
